//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.span`
    background-color: var(--light-1);
    border-radius: 50%;
    width: 35px;
    height: 35px;
    transition: 0.35s;
    position: relative;
    user-select: none;
    cursor: pointer;
    & span {
        color: var(--light-gray-5);
        font-size: 14px;
        font-weight: bold;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    &.selected {
        background-color: var(--purple-2);
        span {
            color: var(--light-1);
        }
    }
`;